<template>
	<div id="businessBox" v-cloak @click="upTopNav">
		<a class="businessConBox" v-for="items in busData" :href="items.jump_url" target="_blank">
			<p class="businessTitle">{{items.title}}</p>
			<img :src="items.img_url" alt="">
			<span class="businessTxt">{{items.content}}</span>
		</a>

		<div class="homeBotTxt">
	        <p>Copyright ©2018 思考乐教育</p>
	        <div>
	          <router-link to="/LegalDeclaration">法律声明</router-link>
	          <span class="l">|</span>
	          <router-link :to="{name:'CampusCon',query:{id:1,cityId:1001}}">校区导航</router-link>
	        </div>
      	</div>	
	</div>
</template>

<script>
export default{
	name:'business',
	data(){
		return{
			busData: ''
		}
	},
	created(){
		this.axios.get(this.$root.baseUrl+'/wap/brand/brandList')
		.then(res=>{
			this.busData = res.data;
			console.log(this.busData)
		})
		.catch(e=>{
			console.log(e)
		})
	},
    methods:{
        upTopNav:function(){
          document.getElementById("navLinkBox").classList.remove('active');
          document.getElementById("navLinkBox").style.transition = "0.5s";
        }
    }	
}
</script>

<style >
#businessBox{
    margin: 3.222rem auto 0;
    width: 100%;
    padding: 0.8rem 1rem 0;
    box-sizing: border-box;
    margin-bottom: 2rem;
}
.businessConBox{
	width: 100%;
	font-size: 0;
    margin-bottom: 2.93333rem;
    display: inline-block;	
}
.businessTitle{
    font-size: 1.6rem;
    font-weight: bold;
    color: #333;
    margin: 1rem 0 1.6rem;
    display: inline-block;
}
.businessConBox img{
	width: 100%;
    border-radius: 4px;
}
.businessTxt{
    font-size: 0.93333rem;
    color: #333;
    padding: 1.5333rem 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: inline-block;
    line-height: 1.333rem;
}
[v-cloak]{ display :none }
.homeBotTxt{
    /* position: fixed; */
    /* bottom: 1rem; */
    text-align: center;
    font-size: 1rem;
    color: #333;
    width: 100%;
    z-index: 99;
    color: #333;
    /* font-weight: 100; */
    margin: 4.8rem 0 1.333rem 0;
}
.homeBotTxt p{
    margin-bottom: 0.5rem;
    color: #808080;
}
.homeBotTxt a{
    color: #bfbfbf;
    text-decoration: underline;
    font-size: 0.8rem;
    /* font-weight: 100; */
}
.homeBotTxt .l{
    font-size: 0.8rem;
    display: inline-block;
    font-weight: bold;
    margin: 0 0.5rem;
    color: #bfbfbf;
}
</style>


// WEBPACK FOOTER //
// src/components/business/Business.vue